import { render, staticRenderFns } from "./BalancesPlanEdit.vue?vue&type=template&id=74b2c0ed&scoped=true&"
import script from "./BalancesPlanEdit.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2c0ed",
  null
  
)

export default component.exports